<template>
    <DxResponsiveBox>
        <DxRow></DxRow>
        <DxRow></DxRow>
        <DxRow screen="xs"></DxRow>
        <DxRow screen="xs"></DxRow>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxItem :ratio="1">
            <DxLocation :col="0" :row="0" screen="sm md lg"></DxLocation>
            <DxLocation :col="0" :colspan="2" :row="0" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        Всего абитуриентов<br>{{ mainStatistics.CountApplicants }}
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="1" :row="0" screen="sm md lg"></DxLocation>
            <DxLocation :col="2" :colspan="2" :row="0" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        КЦП<br>{{ mainStatistics.CountKPC }}
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="2" :row="0" screen="sm md lg"></DxLocation>
            <DxLocation :col="0" :colspan="2" :row="1" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        Зачислено бюджет<br>{{ mainStatistics.CountCreditedToBudget }}
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="3" :row="0" screen="sm md lg"></DxLocation>
            <DxLocation :col="2" :colspan="2" :row="1" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        Зачислено контракт<br>{{ mainStatistics.CountCreditedToContract }}
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="0" :row="1" screen="sm md lg"></DxLocation>
            <DxLocation :col="0" :colspan="2" :row="2" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        Ср. балл ЕГЭ (осн. места)<br>{{ mainStatistics.BudgetKcpAverageMark }}
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="1" :row="1" screen="sm md lg"></DxLocation>
            <DxLocation :col="2" :colspan="2" :row="2" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        Ср. балл ЕГЭ (осн. места + квоты)<br>{{ mainStatistics.BudgetAverageMark }}
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="2" :row="1" screen="sm md lg"></DxLocation>
            <DxLocation :col="0" :colspan="2" :row="3" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        Средний балл ЕГЭ (контракт)<br>{{ mainStatistics.ContractAverageMark }}
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="3" :row="1" screen="sm md lg"></DxLocation>
            <DxLocation :col="2" :colspan="2" :row="3" screen="xs"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        Средний балл ЕГЭ (общий)<br>{{ mainStatistics.AllAverageMark }}
                    </div>
                </div>
            </template>
        </DxItem>
    </DxResponsiveBox>
    <DxResponsiveBox :screen-by-width="getScreenByWidth">
        <DxRow :baseSize="450"></DxRow>
        <DxRow :baseSize="450"></DxRow>
        <DxRow :baseSize="450"></DxRow>
        <DxRow :baseSize="450"></DxRow>
        <DxRow :baseSize="450" screen="md sm xs"></DxRow>
        <DxRow :baseSize="450" screen="sm xs"></DxRow>
        <DxRow :baseSize="450" screen="xs sm"></DxRow>
        <DxRow :baseSize="450" screen="xs sm"></DxRow>
        <DxRow :baseSize="450" screen="xs sm"></DxRow>
        <DxRow :baseSize="450" screen="xs sm"></DxRow>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxCol></DxCol>
        <DxItem :ratio="1" :shrink="1">
            <DxLocation :col="0" :colspan="2" :row="0" screen="lg"></DxLocation>
            <DxLocation :col="0" :colspan="3" :row="0" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="0" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        <StatPue :statistics="mainStatistics.DocumentSources" title="Способ подачи" />
                    </div>
                </div>

            </template>
        </DxItem>
        <DxItem :ratio="1" :shrink="1">
            <DxLocation :col="2" :colspan="2" :row="0" screen="lg"></DxLocation>
            <DxLocation :col="3" :colspan="3" :row="0" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="1" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        <StatPue :statistics="mainStatistics.OriginalityDocuments"
                            title="Наличие подлинника/ эл.подлинника ЕПГУ" />
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1" :shrink="1">
            <DxLocation :col="4" :colspan="2" :row="0" screen="lg"></DxLocation>
            <DxLocation :col="0" :colspan="3" :row="1" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="2" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-light">

                    <div class="block">
                        <StatBlock :statistics="mainStatistics.Citizenship" title="Гражданство" />
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="0" :colspan="2" :row="1" screen="lg"></DxLocation>
            <DxLocation :col="3" :colspan="3" :row="1" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="3" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        <StatBlock :statistics="mainStatistics.StudyForms" title="По формам обучения" />

                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="2" :colspan="2" :row="1" screen="lg"></DxLocation>
            <DxLocation :col="0" :colspan="3" :row="2" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="4" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        <StatBlock :statistics="mainStatistics.EducationLevels" title="По уровням обучения" />
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="4" :colspan="2" :row="1" screen="lg"></DxLocation>
            <DxLocation :col="3" :colspan="3" :row="2" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="5" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        <StatBlock :statistics="mainStatistics.PlaceTypes" title="По конкурсным группам" />
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1" :shrink="1">
            <DxLocation :col="0" :colspan="2" :row="2" screen="lg"></DxLocation>
            <DxLocation :col="0" :colspan="3" :row="3" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="6" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        <StatBlock :statistics="this.Top5Spec" title="Топ 10 приоритетных направлений" />
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="2" :colspan="2" :row="2" screen="lg"></DxLocation>
            <DxLocation :col="3" :colspan="3" :row="3" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="7" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        <StatPue :statistics="mainStatistics.Regions" title="По регионам" />
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="4" :colspan="2" :row="2" screen="lg"></DxLocation>
            <DxLocation :col="0" :colspan="3" :row="4" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="8" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-light">
                    <div class="block">
                        <StatBlock :statistics="mainStatistics.AverageSubjectEgeMarks"
                            title="Средний балл ЕГЭ по предметам" />
                    </div>
                </div>
            </template>
        </DxItem>
        <DxItem :ratio="1">
            <DxLocation :col="0" :colspan="2" :row="3" screen="lg"></DxLocation>
            <DxLocation :col="3" :colspan="3" :row="4" screen="md"></DxLocation>
            <DxLocation :col="0" :colspan="6" :row="9" screen="xs sm"></DxLocation>
            <template>
                <div class="rect demo-dark">
                    <div class="block">
                        <DxDataGrid :allow-column-reordering="true" :column-hiding-enabled="false"
                            :data-source="chelyabinskAverageMarks" :remote-operations="false"
                            :row-alternation-enabled="true" :show-borders="true" :word-wrap-enabled="true"
                            :paging="{ pageSize: 100 }" :show-row-lines="true" :focused-row-enabled="true"
                            @content-ready="onContentReady">
                            <DxExport :enabled="true" />

                            <DxColumn alignment="left" caption="Предмет" data-field="SubjectName" data-type="number" />
                            <DxColumn caption="Подлинник">
                                <DxColumn :width="70" alignment="right" caption="Количество"
                                    data-field="OriginalNumberOfRecords" data-type="number" />
                                <DxColumn :width="70" alignment="right" caption="Балл" data-field="OriginalAverageMarks"
                                    data-type="number" />
                            </DxColumn>

                            <DxColumn caption="Все">
                                <DxColumn :width="70" alignment="right" caption="Количество"
                                    data-field="AllNumberOfRecords" data-type="number" />
                                <DxColumn :width="70" alignment="right" caption="Балл" data-field="AllAverageMarks"
                                    data-type="number" />
                            </DxColumn>
                            <DxToolbar>
                                <gridItem location="center">Средний балл ЕГЭ по Челябинской области</gridItem>
                                <gridItem location="after" name="exportButton"/>
                            </DxToolbar>
                        </DxDataGrid>
                    </div>
                </div>
            </template>
        </DxItem>
    </DxResponsiveBox>
    <div class="statistics_grid">
        <DxDataGrid :allow-column-reordering="true" :column-hiding-enabled="false" :data-source="dataGridStatistics"
            :remote-operations="false" :row-alternation-enabled="true" :show-borders="true" :word-wrap-enabled="true"
            :paging="{ pageSize: 100 }" :show-row-lines="true" :focused-row-enabled="true" :height="'800px'"
            @content-ready="onContentReady">
            <DxExport :enabled="true" />
            <DxColumn :min-width="300" caption="Направление" data-field="CompetitionName" />
            <DxColumn :min-width="300" caption="Cпециализация" data-field="StudySpecializationsName" />
            <DxColumn :width="150" caption="Уровень образования" data-field="EducationLevelName" />
            <DxColumn :width="100" alignment="right" caption="Форма обучения" data-field="StudyFormName"
                format="currency" />
            <DxColumn :width="100" alignment="right" caption="Институт" data-field="FacultyShortName"
                format="currency" />
            <DxColumn caption="Бюджет">
                <DxColumn :width="70" alignment="right" caption="КЦП" data-field="BudgetPlaceCount"
                    data-type="number" />
                <DxColumn :width="100" alignment="right" caption="Заявлений" data-field="BudgetApplicationsCount"
                    data-type="number" />
                <DxColumn :width="130" alignment="right" caption="По высшему" data-field="BudgetFirstPriorityCount"
                    data-type="number" />
                <DxColumn :width="110" alignment="right" caption="Занято КЦП" data-field="BudgetOccupiedCount"
                    data-type="number" />
                <DxColumn :width="70" alignment="right" caption="Ср. балл ЕГЭ" data-field="BudgetEgeAverageMark"
                    data-type="number" />
            </DxColumn>

            <DxColumn caption="Контракт">
                <DxColumn :width="70" alignment="right" caption="План" data-field="ContractPlaceCount"
                    data-type="number" />
                <DxColumn :width="100" alignment="right" caption="Заявлений" data-field="ContractApplicationsCount"
                    data-type="number" />
                <DxColumn :width="110" alignment="right" caption="Договоров" data-field="ContractCount"
                    data-type="number" />
                <DxColumn :width="110" alignment="right" caption="Оплачено договоров" data-field="ContractPaidCount"
                    data-type="number" />
                <DxColumn :width="70" alignment="right" caption="Ср. балл ЕГЭ" data-field="ContractEgeAverageMark"
                    data-type="number" />

            </DxColumn>
            <DxGroupPanel :visible="true" />
            <DxSearchPanel :highlight-case-sensitive="true" :visible="true" />
            <DxGrouping :auto-expand-all="false" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />
            <!-- <DxPager :allowed-page-sizes="pageSizes"
                    :show-page-size-selector="true"/> -->
            <!-- <DxPaging :page-size="10"/>  -->
        </DxDataGrid>
    </div>


    <DxChart id="chart" :data-source="applicationStatistics" palette="Harmony Light" title="Количество абитуриентов">
        <DxCommonSeriesSettings argument-field="Name" />
        <DxSeries axis="frequency" color="#fac29a" name=" " type="bar" value-field="Value" />

        <DxArgumentAxis>
            <DxLabel overlapping-behavior="stagger" />
        </DxArgumentAxis>

        <DxValueAxis :tick-interval="300" name="frequency" position="left" />
        <DxValueAxis :show-zero="true" :tick-interval="20" :value-margins-enabled="false" name="percentage"
            position="right">
            <DxLabel :customize-text="customizePercentageText" />
            <DxConstantLine :value="80" :width="2" color="#fc3535" dash-style="dash">
                <DxLabel :visible="false" />
            </DxConstantLine>
        </DxValueAxis>

        <DxTooltip :enabled="true" :shared="true" />

        <DxLegend horizontal-alignment="center" vertical-alignment="top" />
    </DxChart>

    <DxChart id="chart" :data-source="contractStatistics" palette="Harmony Light" title="Количество договоров">
        <DxCommonSeriesSettings argument-field="Name" />
        <DxSeries axis="frequency" color="#fac29a" name=" " type="bar" value-field="Value" />

        <DxArgumentAxis>
            <DxLabel overlapping-behavior="stagger" />
        </DxArgumentAxis>

        <DxValueAxis :tick-interval="300" name="frequency" position="left" />
        <DxValueAxis :show-zero="true" :tick-interval="20" :value-margins-enabled="false" name="percentage"
            position="right">
            <DxLabel :customize-text="customizePercentageText" />
            <DxConstantLine :value="80" :width="2" color="#fc3535" dash-style="dash">
                <DxLabel :visible="false" />
            </DxConstantLine>
        </DxValueAxis>

        <DxTooltip :enabled="true" :shared="true" />

        <DxLegend horizontal-alignment="center" vertical-alignment="top" />
    </DxChart>

    <DxChart id="chart" :data-source="cumulativeStatisticsByYears" palette="Harmony Light" title="Статистика заявлений">
        <DxCommonSeriesSettings argument-field="Date" />
        <DxSeries type="bar" name="Количество заявлений в день (2025)" value-field="CurStatAppCount" axis="curAx" />
        <DxSeries type="line" name="Всего заявлений (2025)" value-field="CurStatAppCumulative" axis="cumulativeAx" />
        <DxSeries type="bar" name="Количество заявлений в день (2024)" value-field="PrevStatAppCount" axis="curAx" />
        <DxSeries type="line" name="Всего заявлений (2024)" value-field="PrevStatAppCumulative" axis="cumulativeAx"/>

        <DxArgumentAxis>
            <DxLabel overlapping-behavior="stagger" />
        </DxArgumentAxis>

        <DxValueAxis :tick-interval="500" name="cumulativeAx" position="left" title="Всего заявлений" />
        <DxValueAxis name="curAx" position="right" title="Заявлений в день" />

        <DxTooltip :enabled="true" :shared="true" />
        <DxLegend horizontal-alignment="center" vertical-alignment="top" />
    </DxChart>

    <DxChart id="chart" :data-source="cumulativeStatisticsByYears" palette="Harmony Light" title="Статистика договоров">
        <DxCommonSeriesSettings argument-field="Date" />
        <DxSeries type="bar" name="Количество договоров в день (2025)" value-field="CurStatContractCount" axis="curAx" />
        <DxSeries type="line" name="Всего договоров (2025)" value-field="CurStatContractCumulative" axis="cumulativeAx" />
        <DxSeries type="bar" name="Количество договоров в день (2024)" value-field="PrevStatContractCount" axis="curAx" />
        <DxSeries type="line" name="Всего договоров (2024)" value-field="PrevStatContractCumulative" axis="cumulativeAx"/>

        <DxArgumentAxis>
            <DxLabel overlapping-behavior="stagger" />
        </DxArgumentAxis>

        <DxValueAxis :tick-interval="500" name="cumulativeAx" position="left" title="Всего договоров" />
        <DxValueAxis name="curAx" position="right" title="Договоров в день" />

        <DxTooltip :enabled="true" :shared="true" />
        <DxLegend horizontal-alignment="center" vertical-alignment="top" />
    </DxChart>
</template>

<script>
import DxChart, {
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxConstantLine, DxLabel, DxLegend, DxSeries,
    DxTooltip,
    DxValueAxis
} from "devextreme-vue/chart";
import {
    DxColumn,
    DxDataGrid,
    DxGrouping,
    DxGroupPanel,
    // DxPager,
    // DxPaging,
    DxSearchPanel,
    DxFilterRow,
    DxHeaderFilter,
    DxExport,
    DxToolbar, 
    DxItem as gridItem
} from "devextreme-vue/data-grid";
import { DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow, } from "devextreme-vue/responsive-box";
import StatBlock from "@/components/StatBlock.vue";
import StatPue from "@/components/StatPue.vue";
import CustomStore from "devextreme/data/custom_store";
import axios from "@/plugins/axios";

let collapsed = false;

export default {
    name: "StatisticsView",
    components: {
        StatPue,
        StatBlock,
        DxResponsiveBox,
        DxLocation,
        DxCol,
        DxRow,
        DxItem,
        DxDataGrid,
        DxColumn,
        DxGrouping,
        DxGroupPanel,
        // DxPager,
        // DxPaging,
        DxSearchPanel,
        DxChart,
        DxArgumentAxis,
        DxCommonSeriesSettings,
        DxLabel,
        DxLegend,
        DxSeries,
        DxTooltip,
        DxValueAxis,
        DxConstantLine,
        DxFilterRow,
        DxHeaderFilter,
        DxExport,
        gridItem,
        DxToolbar
    },
    data() {
        return {
            mainStatistics: {
                CountApplicants: 0,
                CountKPC: 0,
                CountCreditedToBudget: 0,
                CountCreditedToContract: 0,
                DocumentSources: [],
                OriginalityDocuments: [],
                Citizenship: [],
                StudyForms: [],
                EducationLevels: [],
                PlaceTypes: [],
                Regions: [],
                AverageSubjectEgeMarks: []
            },
            Top5Spec: [],
            dataGridStatistics: new CustomStore({
                key: "Id",
                load: () => {
                    var tmp = axios.get("/AdmissionStatistics/GetDataGridStatistics");
                    tmp.then(res => {
                        if (res != undefined) {
                            /*
                            var names = ['01.03.02 Прикладная математика и информатика',
                                '40.03.01 Юриспруденция',
                                '08.03.01 Строительство',
                                '09.03.04 Программная инженерия',
                                '09.03.01 Информатика и вычислительная техника',
                                '13.03.02 Электроэнергетика и электротехника',
                                '10.03.01 Информационная безопасность',
                                '22.03.02 Металлургия',
                                '15.03.06 Мехатроника и робототехника',
                                '15.03.01 Машиностроение']
                                */
                            this.Top5Spec = res.data/*.filter(c => names.includes(c.CompetitionName) && c.StudyFormName == "очная")*/
                                .sort((a, b) => b.BudgetApplicationsCount - a.BudgetApplicationsCount).slice(0, 10)
                                .map(c => {
                                    return {
                                        Name: c.CompetitionName,
                                        Value: c.BudgetApplicationsCount,
                                        Id: c.Id
                                    }
                                }).sort((a, b) => a.Value - b.Value);
                        }

                    });

                    return tmp;
                },
            }),
            pageSizes: [10, 25, 50, 100],
            onContentReady(e) {
                if (!collapsed) {
                    e.component.expandRow(['EnviroCare']);
                    collapsed = true;
                }
            },

            applicationStatistics: new CustomStore({
                key: "Name",
                load: () => {
                    return axios.get("/AdmissionStatistics/GetApplicationStatistics");
                },
            }),

            contractStatistics: new CustomStore({
                key: "Name",
                load: () => {
                    return axios.get("/AdmissionStatistics/GetContractStatistics");
                },
            }),

            chelyabinskAverageMarks: new CustomStore({
                key: "SubjectName",
                load: () => {
                    return axios.get("/AdmissionStatistics/GetChelyabinskAverageEgeMarks");
                }
            }),

            cumulativeStatisticsByYears: new CustomStore({
                key: "Date",
                load: () => {
                    return axios.get("/AdmissionStatistics/CompareStatisticYearCumulative");
                }
            }),
        };
    },
    methods: {
        customizePercentageText({ valueText }) {
            return `${valueText}%`;
        },

        async getStatistics() {
            await axios.get("/AdmissionStatistics/GetMainStatistics").then(res => {
                if (res != undefined)
                    this.mainStatistics = res.data;
            });

        },
        getScreenByWidth(width) {
            if (width > 1475)
                return "lg"
            if (width > 992)
                return "md"
            if (width > 768)
                return "sm"
            return "xs"
        }
    },
    async mounted() {
        this.getStatistics();

        setInterval(() => {
            this.getStatistics();
            this.dataGridStatistics.load();
            this.applicationStatistics.load();
            this.contractStatistics.load();
            this.cumulativeStatisticsByYears.load();
        }, 180000)//3min
    }
}
</script>

<style scoped>
.rect {
    text-align: center;
    font-size: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 100%;
    display: flex;
}

.demo-light {
    background: #eae4c7;
}

.demo-dark {
    background: #a1afa1;
}

.demo-dark.header {
    background: rgba(243, 158, 108, 0.5);
}

.demo-dark.footer {
    background: rgba(123, 155, 207, 0.5);
}

.small {
    height: 50px;
    border: 1px solid lightgray;
}

.parent {}

.block {
    margin: auto;
}

.dx-field-label {
    float: none;
    width: 200px;
    font-size: 23px;
    color: black;
    text-align: left;
    padding-left: 10px;
}

#chart {
    height: 440px;
}

.tooltip-header {
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 500;
    padding-bottom: 5px;
    border-bottom: 1px solid #c5c5c5;
}

.tooltip-body {
    width: 170px;
}

.tooltip-body .series-name {
    font-weight: normal;
    opacity: 0.6;
    display: inline-block;
    line-height: 1.5;
    padding-right: 10px;
    width: 126px;
}

.tooltip-body .value-text {
    display: inline-block;
    line-height: 1.5;
    width: 30px;
}

.statistics_grid {
    height: 800px;
    border: 15px solid #CBD7E9;
    padding: 5px;
}
</style>